import { ModuleFE_EncounterMetadata } from "./ModuleFE_EncounterMetadata.js";
export const ModulePackFE_EncounterMetadataDB = [ModuleFE_EncounterMetadata];
//# sourceMappingURL=module-pack.js.map